import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import { Text } from '@sitecore-jss/sitecore-jss-react';

import { throttle, isMobile } from "../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { postApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { trackGA4Event } from '../utilities/FrontFunctions/AoxTrackingFunctions'

import ObjExpertisePointsAside from './inc/ObjExpertisePointsAside'
import ObjFavoriteFormationAside from './inc/ObjFavoriteFormationAside'
import ObjMenuThematiqueAside from './inc/ObjMenuThematiqueAside'
import ObjDirectComptoirDermato from './inc/ObjDirectComptoirDermato'
import ObjProduitsAssociesComptoirDermato from './inc/ObjProduitsAssociesComptoirDermato'
import ObjOutilsDownloadComptoirDermato from './inc/ObjOutilsDownloadComptoirDermato'
import ObjEssentielMinuteComptoirDermato from './inc/ObjEssentielMinuteComptoirDermato'
import ModalFormationsFav from "./inc/Modal/ModalFormationsFav"
import ObjRetour from "./inc/ObjRetour";

class PageThemeAv extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
            apiDatas: null,
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

    fetchData = () => {
        const { scDatas } = this.props.fields.data;
        getApiDatas(`/apiaox/Call/PageThemeAv?sThemeId=${scDatas.id}&sBrandCode=${scDatas.ListBrand[0]?.codeAbbrege.value}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas })
            window.scrollTo(0,0);
        })
    };

	componentDidMount() {
        this.fetchData();
	}
    
    componentDidUpdate(prevProps) {
        // contrôle que sur le ThemeId; dans les ScDatas, ThemeId => BrandCode, donc si le BrandCode a changé, le ThemeId a changé
        if (this.props.fields.data?.scDatas?.id !== prevProps.fields.data?.scDatas?.id) {
            this.fetchData();
        }
    }
    
    handleButtonFav(id) {
        //pushs possibles sur plus loin et associés
        //!! liste des favori à gérer pour le aside
        var datasTraining = this.state.apiDatas.ThemeFormations.find(t => t.Training_ItemTraining_Id === id);
        if(!datasTraining){ datasTraining = this.state.apiDatas.ThemeProduitsAssocies.find(t => t.Training_ItemTraining_Id === id); }
        if(datasTraining){
            if(!datasTraining.Training_IsFavorite){
                //ajouter favori
                document.body.classList.add('is-loading')
                trackGA4Event(window.trackDatas, "training_add_favorite", "training", "training add favorite", "star icon");
                postApiDatas(`/apiaox/Call/AddTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les listes
                        newDatas.ThemeFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        newDatas.ThemeProduitsAssocies.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});

                        //ajouter à la liste des favoris
                        datasTraining.Training_IsFavorite = true; newDatas.TrainingsFavorite.unshift(datasTraining);

                        this.setState({ apiDatas: newDatas })
                        
                        if(!localStorage.getItem('dontShowAgainModalMAJFormationsFav')){
                            this.ModalFormationsFav.openModal();
                        }
                    }
                });
            } else {
                //supprimer favori
                document.body.classList.add('is-loading')
                postApiDatas(`/apiaox/Call/RemoveTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les listes
                        newDatas.ThemeFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        newDatas.ThemeProduitsAssocies.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});

                        //supprimer des favoris
                        newDatas.TrainingsFavorite = this.state.apiDatas.TrainingsFavorite.filter(t => t.Training_ItemTraining_Id !== id);
                        
                        this.setState({ apiDatas: newDatas })
                    }
                });
            }
        }
    }

	render() {
        const pageDatas = this.props.sitecoreContext.route?.fields;
        const { scDatas, scDatasComptoir } = this.props.fields.data;
        const { apiDatas } = this.state;

		return (<>{ scDatas && apiDatas && <>
			<section className="obj_section section_hero_formation">
				<div className="ctn_section">
					<div className="ctn_text">
						<h2 className="t_subtitle">{scDatas.ListSegment[0].pageTitle.value}</h2>
                        { pageDatas && <Text className="t_title" field={pageDatas["Page Title"]} tag="h1"></Text> }

                        <ObjRetour/>
					</div>
				</div>
			</section>

            {apiDatas.UserBrandExpertise && this.state.isMobile &&
                <ObjExpertisePointsAside datasExpertise={apiDatas.UserBrandExpertise}/>	
            }

            <section className="obj_section section_aside_content">
				<div className="ctn_section">
					<div className="ctn_columns">

						<div className="ctn_content">

							<div className="ctn_row_thematique">
								
                                {scDatas.lEssentielle?.targetItems?.length > 0 && <ObjEssentielMinuteComptoirDermato datasEssentielle={scDatas.lEssentielle.targetItems[0]}/>}

                                {scDatas.nosOutils?.targetItems?.length > 0 && <ObjOutilsDownloadComptoirDermato datasOutils={scDatas.nosOutils.targetItems}/>}

							</div>

                            {apiDatas.ThemeFormations && <ObjDirectComptoirDermato datasTrainings={apiDatas.ThemeFormations} dataType="ThemeAv" datasComptoir={scDatasComptoir} handleButtonFav={this.handleButtonFav}/>}

                            {apiDatas.ThemeProduitsAssocies && <ObjProduitsAssociesComptoirDermato datasTrainings={apiDatas.ThemeProduitsAssocies} handleButtonFav={this.handleButtonFav}/>}

						</div>

						<div className="ctn_aside">
							
                            {apiDatas.UserBrandExpertise && !this.state.isMobile && <ObjExpertisePointsAside datasExpertise={apiDatas.UserBrandExpertise}/>	}

                            {scDatas.ListSegment[0]?.ListThemeFolder[0]?.ListTheme && <ObjMenuThematiqueAside datasThemes={scDatas.ListSegment[0]?.ListThemeFolder[0]?.ListTheme} themeId={scDatas.id}/>}

                            {apiDatas.TrainingsFavorite?.length >0 && <ObjFavoriteFormationAside datasTrainings={apiDatas.TrainingsFavorite}/>}

						</div>

					</div>
				</div>
			</section>

            <ModalFormationsFav 
                onRef={ref => (this.ModalFormationsFav = ref)} 
                modalTitle=""
                modalText="Vous venez d'ajouter cette formation à votre liste de favoris"
                modalCtaText="Retrouver mes favoris"
            />
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(PageThemeAv));